/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addTowerGroupDetails } from '../fn/admin-tower-groups-api/add-tower-group-details';
import { AddTowerGroupDetails$Params } from '../fn/admin-tower-groups-api/add-tower-group-details';
import { createPaymentConfiguration } from '../fn/admin-tower-groups-api/create-payment-configuration';
import { CreatePaymentConfiguration$Params } from '../fn/admin-tower-groups-api/create-payment-configuration';
import { createTowerGroup } from '../fn/admin-tower-groups-api/create-tower-group';
import { CreateTowerGroup$Params } from '../fn/admin-tower-groups-api/create-tower-group';
import { deletePaymentConfiguration } from '../fn/admin-tower-groups-api/delete-payment-configuration';
import { DeletePaymentConfiguration$Params } from '../fn/admin-tower-groups-api/delete-payment-configuration';
import { deleteTowerGroup } from '../fn/admin-tower-groups-api/delete-tower-group';
import { DeleteTowerGroup$Params } from '../fn/admin-tower-groups-api/delete-tower-group';
import { deleteTowerGroupDetails } from '../fn/admin-tower-groups-api/delete-tower-group-details';
import { DeleteTowerGroupDetails$Params } from '../fn/admin-tower-groups-api/delete-tower-group-details';
import { deleteTowerGroupImage } from '../fn/admin-tower-groups-api/delete-tower-group-image';
import { DeleteTowerGroupImage$Params } from '../fn/admin-tower-groups-api/delete-tower-group-image';
import { getAllPaymentConfigurations } from '../fn/admin-tower-groups-api/get-all-payment-configurations';
import { GetAllPaymentConfigurations$Params } from '../fn/admin-tower-groups-api/get-all-payment-configurations';
import { getAllTowerGroupDetails } from '../fn/admin-tower-groups-api/get-all-tower-group-details';
import { GetAllTowerGroupDetails$Params } from '../fn/admin-tower-groups-api/get-all-tower-group-details';
import { getAllTowerGroups } from '../fn/admin-tower-groups-api/get-all-tower-groups';
import { GetAllTowerGroups$Params } from '../fn/admin-tower-groups-api/get-all-tower-groups';
import { getAllTowerGroupsRef } from '../fn/admin-tower-groups-api/get-all-tower-groups-ref';
import { GetAllTowerGroupsRef$Params } from '../fn/admin-tower-groups-api/get-all-tower-groups-ref';
import { getAllUniqueTowerGroupDetails } from '../fn/admin-tower-groups-api/get-all-unique-tower-group-details';
import { GetAllUniqueTowerGroupDetails$Params } from '../fn/admin-tower-groups-api/get-all-unique-tower-group-details';
import { getOrganizationRelations } from '../fn/admin-tower-groups-api/get-organization-relations';
import { GetOrganizationRelations$Params } from '../fn/admin-tower-groups-api/get-organization-relations';
import { getTowerGroup } from '../fn/admin-tower-groups-api/get-tower-group';
import { GetTowerGroup$Params } from '../fn/admin-tower-groups-api/get-tower-group';
import { getTowerGroupAllocationPolicies } from '../fn/admin-tower-groups-api/get-tower-group-allocation-policies';
import { GetTowerGroupAllocationPolicies$Params } from '../fn/admin-tower-groups-api/get-tower-group-allocation-policies';
import { getTowerGroupCurrentUsers } from '../fn/admin-tower-groups-api/get-tower-group-current-users';
import { GetTowerGroupCurrentUsers$Params } from '../fn/admin-tower-groups-api/get-tower-group-current-users';
import { getTowerGroupImage3 } from '../fn/admin-tower-groups-api/get-tower-group-image-3';
import { GetTowerGroupImage3$Params } from '../fn/admin-tower-groups-api/get-tower-group-image-3';
import { getTowerStatuses1 } from '../fn/admin-tower-groups-api/get-tower-statuses-1';
import { GetTowerStatuses1$Params } from '../fn/admin-tower-groups-api/get-tower-statuses-1';
import { getWidgetTowerGroups } from '../fn/admin-tower-groups-api/get-widget-tower-groups';
import { GetWidgetTowerGroups$Params } from '../fn/admin-tower-groups-api/get-widget-tower-groups';
import { getWidgetTowerGroupsUsage } from '../fn/admin-tower-groups-api/get-widget-tower-groups-usage';
import { GetWidgetTowerGroupsUsage$Params } from '../fn/admin-tower-groups-api/get-widget-tower-groups-usage';
import { ImageUploadResponse } from '../models/image-upload-response';
import { PageDtoTowerGroupTowerGroupDto } from '../models/page-dto-tower-group-tower-group-dto';
import { PaymentConfigurationDto } from '../models/payment-configuration-dto';
import { SimpleList } from '../models/simple-list';
import { TowerGroupDetailsDto } from '../models/tower-group-details-dto';
import { TowerGroupDto } from '../models/tower-group-dto';
import { TowerGroupRefDto } from '../models/tower-group-ref-dto';
import { TowerGroupRelationsDto } from '../models/tower-group-relations-dto';
import { TowerGroupUsageDto } from '../models/tower-group-usage-dto';
import { updatePaymentConfiguration } from '../fn/admin-tower-groups-api/update-payment-configuration';
import { UpdatePaymentConfiguration$Params } from '../fn/admin-tower-groups-api/update-payment-configuration';
import { updateTowerGroup } from '../fn/admin-tower-groups-api/update-tower-group';
import { UpdateTowerGroup$Params } from '../fn/admin-tower-groups-api/update-tower-group';
import { updateTowerGroupDetails } from '../fn/admin-tower-groups-api/update-tower-group-details';
import { UpdateTowerGroupDetails$Params } from '../fn/admin-tower-groups-api/update-tower-group-details';
import { uploadTowerGroupImage } from '../fn/admin-tower-groups-api/upload-tower-group-image';
import { UploadTowerGroupImage$Params } from '../fn/admin-tower-groups-api/upload-tower-group-image';
import { UserRefDto } from '../models/user-ref-dto';

@Injectable({ providedIn: 'root' })
export class AdminTowerGroupsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updatePaymentConfiguration()` */
  static readonly UpdatePaymentConfigurationPath = '/api/admin/towers/groups/{towerGroupId}/paymentconfigurations/{configId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePaymentConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaymentConfiguration$Response(params: UpdatePaymentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentConfigurationDto>> {
    return updatePaymentConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePaymentConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaymentConfiguration(params: UpdatePaymentConfiguration$Params, context?: HttpContext): Observable<PaymentConfigurationDto> {
    return this.updatePaymentConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentConfigurationDto>): PaymentConfigurationDto => r.body)
    );
  }

  /** Path part for operation `deletePaymentConfiguration()` */
  static readonly DeletePaymentConfigurationPath = '/api/admin/towers/groups/{towerGroupId}/paymentconfigurations/{configId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePaymentConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaymentConfiguration$Response(params: DeletePaymentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePaymentConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePaymentConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaymentConfiguration(params: DeletePaymentConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deletePaymentConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateTowerGroupDetails()` */
  static readonly UpdateTowerGroupDetailsPath = '/api/admin/towers/groups/{towerGroupId}/details/{detailsId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTowerGroupDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerGroupDetails$Response(params: UpdateTowerGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDetailsDto>> {
    return updateTowerGroupDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTowerGroupDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerGroupDetails(params: UpdateTowerGroupDetails$Params, context?: HttpContext): Observable<TowerGroupDetailsDto> {
    return this.updateTowerGroupDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDetailsDto>): TowerGroupDetailsDto => r.body)
    );
  }

  /** Path part for operation `deleteTowerGroupDetails()` */
  static readonly DeleteTowerGroupDetailsPath = '/api/admin/towers/groups/{towerGroupId}/details/{detailsId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTowerGroupDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroupDetails$Response(params: DeleteTowerGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTowerGroupDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTowerGroupDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroupDetails(params: DeleteTowerGroupDetails$Params, context?: HttpContext): Observable<void> {
    return this.deleteTowerGroupDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTowerGroup()` */
  static readonly GetTowerGroupPath = '/api/admin/towers/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroup$Response(params: GetTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDto>> {
    return getTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroup(params: GetTowerGroup$Params, context?: HttpContext): Observable<TowerGroupDto> {
    return this.getTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDto>): TowerGroupDto => r.body)
    );
  }

  /** Path part for operation `updateTowerGroup()` */
  static readonly UpdateTowerGroupPath = '/api/admin/towers/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTowerGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerGroup$Response(params: UpdateTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDto>> {
    return updateTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTowerGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerGroup(params: UpdateTowerGroup$Params, context?: HttpContext): Observable<TowerGroupDto> {
    return this.updateTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDto>): TowerGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteTowerGroup()` */
  static readonly DeleteTowerGroupPath = '/api/admin/towers/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTowerGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroup$Response(params: DeleteTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTowerGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroup(params: DeleteTowerGroup$Params, context?: HttpContext): Observable<void> {
    return this.deleteTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllTowerGroups()` */
  static readonly GetAllTowerGroupsPath = '/api/admin/towers/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTowerGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroups$Response(params?: GetAllTowerGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoTowerGroupTowerGroupDto>> {
    return getAllTowerGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTowerGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroups(params?: GetAllTowerGroups$Params, context?: HttpContext): Observable<PageDtoTowerGroupTowerGroupDto> {
    return this.getAllTowerGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoTowerGroupTowerGroupDto>): PageDtoTowerGroupTowerGroupDto => r.body)
    );
  }

  /** Path part for operation `createTowerGroup()` */
  static readonly CreateTowerGroupPath = '/api/admin/towers/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTowerGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTowerGroup$Response(params: CreateTowerGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDto>> {
    return createTowerGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTowerGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTowerGroup(params: CreateTowerGroup$Params, context?: HttpContext): Observable<TowerGroupDto> {
    return this.createTowerGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDto>): TowerGroupDto => r.body)
    );
  }

  /** Path part for operation `getAllPaymentConfigurations()` */
  static readonly GetAllPaymentConfigurationsPath = '/api/admin/towers/groups/{towerGroupId}/paymentconfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPaymentConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPaymentConfigurations$Response(params: GetAllPaymentConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentConfigurationDto>>> {
    return getAllPaymentConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPaymentConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPaymentConfigurations(params: GetAllPaymentConfigurations$Params, context?: HttpContext): Observable<Array<PaymentConfigurationDto>> {
    return this.getAllPaymentConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentConfigurationDto>>): Array<PaymentConfigurationDto> => r.body)
    );
  }

  /** Path part for operation `createPaymentConfiguration()` */
  static readonly CreatePaymentConfigurationPath = '/api/admin/towers/groups/{towerGroupId}/paymentconfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPaymentConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPaymentConfiguration$Response(params: CreatePaymentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentConfigurationDto>> {
    return createPaymentConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPaymentConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPaymentConfiguration(params: CreatePaymentConfiguration$Params, context?: HttpContext): Observable<PaymentConfigurationDto> {
    return this.createPaymentConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentConfigurationDto>): PaymentConfigurationDto => r.body)
    );
  }

  /** Path part for operation `getAllTowerGroupDetails()` */
  static readonly GetAllTowerGroupDetailsPath = '/api/admin/towers/groups/{towerGroupId}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTowerGroupDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroupDetails$Response(params: GetAllTowerGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupDetailsDto>>> {
    return getAllTowerGroupDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTowerGroupDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroupDetails(params: GetAllTowerGroupDetails$Params, context?: HttpContext): Observable<Array<TowerGroupDetailsDto>> {
    return this.getAllTowerGroupDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupDetailsDto>>): Array<TowerGroupDetailsDto> => r.body)
    );
  }

  /** Path part for operation `addTowerGroupDetails()` */
  static readonly AddTowerGroupDetailsPath = '/api/admin/towers/groups/{towerGroupId}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTowerGroupDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTowerGroupDetails$Response(params: AddTowerGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupDetailsDto>> {
    return addTowerGroupDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTowerGroupDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTowerGroupDetails(params: AddTowerGroupDetails$Params, context?: HttpContext): Observable<TowerGroupDetailsDto> {
    return this.addTowerGroupDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupDetailsDto>): TowerGroupDetailsDto => r.body)
    );
  }

  /** Path part for operation `uploadTowerGroupImage()` */
  static readonly UploadTowerGroupImagePath = '/api/admin/towers/groups/{id}/image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadTowerGroupImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadTowerGroupImage$Response(params: UploadTowerGroupImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResponse>> {
    return uploadTowerGroupImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadTowerGroupImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadTowerGroupImage(params: UploadTowerGroupImage$Params, context?: HttpContext): Observable<ImageUploadResponse> {
    return this.uploadTowerGroupImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageUploadResponse>): ImageUploadResponse => r.body)
    );
  }

  /** Path part for operation `deleteTowerGroupImage()` */
  static readonly DeleteTowerGroupImagePath = '/api/admin/towers/groups/{id}/image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTowerGroupImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroupImage$Response(params: DeleteTowerGroupImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTowerGroupImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTowerGroupImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTowerGroupImage(params: DeleteTowerGroupImage$Params, context?: HttpContext): Observable<void> {
    return this.deleteTowerGroupImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOrganizationRelations()` */
  static readonly GetOrganizationRelationsPath = '/api/admin/towers/groups/{id}/relations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationRelations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationRelations$Response(params: GetOrganizationRelations$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerGroupRelationsDto>> {
    return getOrganizationRelations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationRelations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationRelations(params: GetOrganizationRelations$Params, context?: HttpContext): Observable<TowerGroupRelationsDto> {
    return this.getOrganizationRelations$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerGroupRelationsDto>): TowerGroupRelationsDto => r.body)
    );
  }

  /** Path part for operation `getTowerGroupImage3()` */
  static readonly GetTowerGroupImage3Path = '/api/admin/towers/groups/{id}/image/{size}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerGroupImage3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupImage3$Response(params: GetTowerGroupImage3$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getTowerGroupImage3(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerGroupImage3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupImage3(params: GetTowerGroupImage3$Params, context?: HttpContext): Observable<string> {
    return this.getTowerGroupImage3$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getTowerGroupCurrentUsers()` */
  static readonly GetTowerGroupCurrentUsersPath = '/api/admin/towers/groups/{id}/currentUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerGroupCurrentUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupCurrentUsers$Response(params: GetTowerGroupCurrentUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRefDto>>> {
    return getTowerGroupCurrentUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerGroupCurrentUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupCurrentUsers(params: GetTowerGroupCurrentUsers$Params, context?: HttpContext): Observable<Array<UserRefDto>> {
    return this.getTowerGroupCurrentUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserRefDto>>): Array<UserRefDto> => r.body)
    );
  }

  /** Path part for operation `getWidgetTowerGroups()` */
  static readonly GetWidgetTowerGroupsPath = '/api/admin/towers/groups/widget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWidgetTowerGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerGroups$Response(params?: GetWidgetTowerGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupDto>>> {
    return getWidgetTowerGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWidgetTowerGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerGroups(params?: GetWidgetTowerGroups$Params, context?: HttpContext): Observable<Array<TowerGroupDto>> {
    return this.getWidgetTowerGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupDto>>): Array<TowerGroupDto> => r.body)
    );
  }

  /** Path part for operation `getWidgetTowerGroupsUsage()` */
  static readonly GetWidgetTowerGroupsUsagePath = '/api/admin/towers/groups/widget/usage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWidgetTowerGroupsUsage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerGroupsUsage$Response(params: GetWidgetTowerGroupsUsage$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupUsageDto>>> {
    return getWidgetTowerGroupsUsage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWidgetTowerGroupsUsage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerGroupsUsage(params: GetWidgetTowerGroupsUsage$Params, context?: HttpContext): Observable<Array<TowerGroupUsageDto>> {
    return this.getWidgetTowerGroupsUsage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupUsageDto>>): Array<TowerGroupUsageDto> => r.body)
    );
  }

  /** Path part for operation `getTowerStatuses1()` */
  static readonly GetTowerStatuses1Path = '/api/admin/towers/groups/statuses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerStatuses1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerStatuses1$Response(params?: GetTowerStatuses1$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getTowerStatuses1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerStatuses1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerStatuses1(params?: GetTowerStatuses1$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getTowerStatuses1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getAllTowerGroupsRef()` */
  static readonly GetAllTowerGroupsRefPath = '/api/admin/towers/groups/ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTowerGroupsRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroupsRef$Response(params?: GetAllTowerGroupsRef$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupRefDto>>> {
    return getAllTowerGroupsRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTowerGroupsRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowerGroupsRef(params?: GetAllTowerGroupsRef$Params, context?: HttpContext): Observable<Array<TowerGroupRefDto>> {
    return this.getAllTowerGroupsRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupRefDto>>): Array<TowerGroupRefDto> => r.body)
    );
  }

  /** Path part for operation `getAllUniqueTowerGroupDetails()` */
  static readonly GetAllUniqueTowerGroupDetailsPath = '/api/admin/towers/groups/details/keys';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllUniqueTowerGroupDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUniqueTowerGroupDetails$Response(params?: GetAllUniqueTowerGroupDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getAllUniqueTowerGroupDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllUniqueTowerGroupDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUniqueTowerGroupDetails(params?: GetAllUniqueTowerGroupDetails$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getAllUniqueTowerGroupDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `getTowerGroupAllocationPolicies()` */
  static readonly GetTowerGroupAllocationPoliciesPath = '/api/admin/towers/groups/allocationPolicies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerGroupAllocationPolicies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupAllocationPolicies$Response(params?: GetTowerGroupAllocationPolicies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'RANDOM' | 'NEAREST'>>> {
    return getTowerGroupAllocationPolicies(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerGroupAllocationPolicies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerGroupAllocationPolicies(params?: GetTowerGroupAllocationPolicies$Params, context?: HttpContext): Observable<Array<'RANDOM' | 'NEAREST'>> {
    return this.getTowerGroupAllocationPolicies$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<'RANDOM' | 'NEAREST'>>): Array<'RANDOM' | 'NEAREST'> => r.body)
    );
  }

}
